module.exports = __webpack_public_path__ + "assets/bca0fa0340891469130b3ca5235b2463.png";